import React from 'react';
import { Box, Typography, IconButton, Card, CardContent, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

const NoticeCard = styled(Card)({
  backgroundColor: '#ff980010',
  border: '1px solid #ff9800',
  marginBottom: '8px',
});

const formatReason = (reason, t) => {
  if (!reason) return t('verificationFailure.defaultReason');
  if (reason.includes('user_cancelled')) return t('verificationFailure.userCancelled');
  if (reason.includes('user_link_display_timeout')) return t('verificationFailure.linkDisplayTimeout');
  if (reason.includes('user_link_start_timeout')) return t('verificationFailure.linkStartTimeout');
  if (reason.includes('presence')) return t('verificationFailure.presenceFailed');
  if (reason.includes('biometric')) return t('verificationFailure.biometricFailed');
  if (reason.includes('hardware')) return t('verificationFailure.hardwareFailed');
  if (reason.includes('proof')) return t('verificationFailure.missingProof');
  if (reason.includes('failed_face_verification')) return t('verificationFailure.faceFailed');
  if (reason.includes('verified_but_did_not_join')) return t('verificationFailure.verifiedNoJoin');
  if (reason.includes('unverified_participant_joined')) return t('verificationFailure.unverifiedJoined');
  if (reason.includes('not_on_guest_list')) return t('verificationFailure.notOnGuestList');
  if (reason.includes('outside_allowed_region')) return t('verificationFailure.outsideRegion');
  if (reason.includes('test_user_not_allowed')) return t('verificationFailure.testUserBlocked');
  if (reason.includes('Unknown failure')) return t('verificationFailure.defaultReason');
  return reason;
};

export default function VerificationFailureNotice({ failure, onDismiss }) {
  const { t } = useTranslation('shared');
  return (
    <NoticeCard>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <WarningAmberIcon sx={{ color: '#ff9800', mt: 0.5 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" fontWeight="bold">
              {t('verificationFailure.title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {failure.name ? `${failure.name}: ` : ''}{formatReason(failure.reason, t)}
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => onDismiss(failure.failure_id)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardContent>
    </NoticeCard>
  );
}
